import React from "react";
import ProductsPageLayout from "./ProductsPageLayout";

export default function Chair() {
  return (
    <>
      <ProductsPageLayout productCategory="chair" />
    </>
  );
}
